import { useLayoutContext } from "client/components/layout"
import {
  Plugin,
  SidePanelTab,
  useGlobalContext,
} from "client/packages/utils/GlobalContext"
import { useCallback } from "react"
import { RozyLayout } from "shared/constants/views"

import { getDefaultVariantForProduct } from "../utils/getDefaultVariantForProduct"

import { FeaturedProductButton } from "./product/FeaturedProductButton"
import { CommerceView, useShopContext } from "./ShopContext"
import { useFeaturedProduct } from "./useFeaturedProduct"

// Wrapper for the FeaturedProductButton, specifically for commerce (not Target)
// Handles data/logic, not UI:
// - Determining the featured product
// - Whether the FeaturedProductButton should be shown
// - What to do when the featured product button is pressed
export const CommerceFeaturedProductButton = () => {
  const {
    state: { isCommercePluginAvailable },
    setPluginOpen,
    setSidePanelOpen,
    setSidePanelSelectedTab,
  } = useGlobalContext()
  const {
    setCurrentlySelectedProductId,
    setCurrentlySelectedVariantId,
    setView,
    setShowImageGallery,
    setAddedProduct,
  } = useShopContext()
  const { layout } = useLayoutContext()
  const { product: featuredProduct } = useFeaturedProduct()
  const variantToShow = featuredProduct
    ? getDefaultVariantForProduct(featuredProduct)
    : null

  const onFeaturedCommerceProductButtonClick = useCallback(() => {
    if (!featuredProduct || !variantToShow) {
      return
    }
    setView(CommerceView.PRODUCT)
    setCurrentlySelectedProductId(featuredProduct.id)
    setCurrentlySelectedVariantId(variantToShow.id)
    setShowImageGallery(false)
    setAddedProduct(null)

    if (layout === RozyLayout.MOBILE) {
      setPluginOpen(Plugin.COMMERCE, true)
    }
    setSidePanelOpen(true)
    setSidePanelSelectedTab(SidePanelTab.COMMERCE)
  }, [
    featuredProduct,
    setPluginOpen,
    setCurrentlySelectedProductId,
    setCurrentlySelectedVariantId,
    layout,
  ])

  const shouldShow =
    isCommercePluginAvailable && featuredProduct && variantToShow

  return (
    <FeaturedProductButton
      onClick={onFeaturedCommerceProductButtonClick}
      product={
        shouldShow
          ? {
              id: featuredProduct.id,
              title: featuredProduct.title,
              priceAmount: variantToShow.price.amount,
              currencyCode: variantToShow.price.currencyCode,
              displayCurrencyCode: false,
              imageSrc: featuredProduct.images.nodes[0]?.url,
            }
          : undefined
      }
    />
  )
}
